import React from 'react';

export default function FirmEnrichmentWidget({ firm }) {
    const hasAny = firm.specialties?.length > 0 || firm.stockInfo || firm.funding || (firm.affiliated && firm.affiliated.length > 0);
    if (!hasAny) return <span className="text-sm text-gray-400">No LinkedIn data</span>;

    return (
        <div className="space-y-4">
            {firm.specialties?.length > 0 && (
                <div>
                    <label className="block text-xs font-medium text-gray-600 mb-1.5">Specialties</label>
                    <div className="flex flex-wrap gap-1.5">
                        {firm.specialties.map((s, i) => (
                            <span key={i} className="px-2 py-0.5 bg-gray-50 text-gray-700 text-xs rounded border border-gray-200">{s}</span>
                        ))}
                    </div>
                </div>
            )}
            {firm.stockInfo && (firm.stockInfo.ticker || firm.stockInfo.exchange || firm.stockInfo.price) && (
                <div>
                    <label className="block text-xs font-medium text-gray-600 mb-1.5">Stock</label>
                    <div className="grid grid-cols-3 gap-2">
                        {firm.stockInfo.ticker && (
                            <div className="px-2 py-1.5 bg-gray-50 rounded">
                                <div className="text-[10px] text-gray-500">Ticker</div>
                                <div className="text-sm text-gray-800 font-medium">{firm.stockInfo.ticker}</div>
                            </div>
                        )}
                        {firm.stockInfo.exchange && (
                            <div className="px-2 py-1.5 bg-gray-50 rounded">
                                <div className="text-[10px] text-gray-500">Exchange</div>
                                <div className="text-sm text-gray-800 font-medium">{firm.stockInfo.exchange}</div>
                            </div>
                        )}
                        {firm.stockInfo.price && (
                            <div className="px-2 py-1.5 bg-gray-50 rounded">
                                <div className="text-[10px] text-gray-500">Price</div>
                                <div className="text-sm text-gray-800 font-medium">{firm.stockInfo.price}</div>
                            </div>
                        )}
                    </div>
                </div>
            )}
            {firm.funding && (
                <div>
                    <label className="block text-xs font-medium text-gray-600 mb-1.5">Funding</label>
                    <div className="px-2 py-1.5 bg-gray-50 rounded text-xs text-gray-600 whitespace-pre-wrap">
                        {typeof firm.funding === 'string' ? firm.funding : JSON.stringify(firm.funding, null, 2)}
                    </div>
                </div>
            )}
            {firm.affiliated && Array.isArray(firm.affiliated) && firm.affiliated.length > 0 && (
                <div>
                    <label className="block text-xs font-medium text-gray-600 mb-1.5">Affiliated Companies</label>
                    <div className="space-y-1">
                        {firm.affiliated.slice(0, 5).map((a, i) => (
                            <div key={i} className="flex items-center gap-1.5 px-2 py-1.5 bg-gray-50 rounded text-xs text-gray-700">
                                <svg className="w-3 h-3 text-gray-400 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" /></svg>
                                {a.title || a.name || (typeof a === 'string' ? a : JSON.stringify(a))}
                            </div>
                        ))}
                        {firm.affiliated.length > 5 && <span className="text-[10px] text-gray-400">+{firm.affiliated.length - 5} more</span>}
                    </div>
                </div>
            )}
        </div>
    );
}
